// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Ak6ao","input":"style_input__ZL8xw","icon":"style_icon__C4mgM"};